import React from 'react';
import { Link } from 'react-router-dom';
import { GraduationCap, Instagram, Linkedin, Youtube } from 'lucide-react';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-border bg-background mt-auto">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 py-10 sm:py-14">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-8">
          {/* Brand */}
          <div className="flex flex-col gap-3 max-w-xs">
            <Link to="/" className="flex items-center gap-2.5 text-foreground hover:opacity-80 transition-opacity">
              <GraduationCap className="h-7 w-7 text-primary" />
              <span className="font-display font-bold text-lg tracking-tight">Your Big Year</span>
            </Link>
            <p className="text-sm text-foreground/50 leading-relaxed">
              Empowering students to grow, learn, and achieve through guided learning paths.
            </p>
            {/* Social icons */}
            <div className="flex items-center gap-3 mt-1">
              <a href="https://www.instagram.com/yourbigyear?igsi=MTJuZ2thbThhMDRvaw==" target="_blank" rel="noopener noreferrer" className="text-foreground/40 hover:text-foreground transition-colors" title="Instagram">
                <Instagram className="h-[18px] w-[18px]" />
              </a>
              <a href="https://www.linkedin.com/company/yourbigyear/" target="_blank" rel="noopener noreferrer" className="text-foreground/40 hover:text-foreground transition-colors" title="LinkedIn">
                <Linkedin className="h-[18px] w-[18px]" />
              </a>
              <a href="https://youtube.com/@yourbigyearprogram?si=Mk_WBR27QoBuS8oX" target="_blank" rel="noopener noreferrer" className="text-foreground/40 hover:text-foreground transition-colors" title="YouTube">
                <Youtube className="h-[18px] w-[18px]" />
              </a>
            </div>
          </div>

          {/* Links */}
          <div className="flex gap-12 sm:gap-16">
            <div className="flex flex-col gap-2.5">
              <h4 className="text-xs font-bold uppercase tracking-[0.12em] text-foreground/40 mb-1">Platform</h4>
              <Link to="/dashboard" className="text-sm text-foreground/60 hover:text-foreground transition-colors">Dashboard</Link>
              <Link to="/leaderboard" className="text-sm text-foreground/60 hover:text-foreground transition-colors">Leaderboard</Link>
              <Link to="/submissions" className="text-sm text-foreground/60 hover:text-foreground transition-colors">Submissions</Link>
            </div>
            <div className="flex flex-col gap-2.5">
              <h4 className="text-xs font-bold uppercase tracking-[0.12em] text-foreground/40 mb-1">Support</h4>
              <Link to="/contact-help" className="text-sm text-foreground/60 hover:text-foreground transition-colors">Contact & Help</Link>
              <Link to="/profile" className="text-sm text-foreground/60 hover:text-foreground transition-colors">Profile</Link>
            </div>
          </div>
        </div>

        {/* Divider + bottom row */}
        <div className="mt-10 pt-6 border-t border-border flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <p className="text-xs text-foreground/40">
            &copy; {year} Your Big Year. All rights reserved.
          </p>
          <p className="text-xs text-foreground/30">
            Built with care for student success.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
